function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icons/status-ok-fill-green");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M32,64 C14.326888,64 0,49.673112 0,32 C0,14.326888 14.326888,0 32,0 C49.673112,0 64,14.326888 64,32 C64,49.673112 49.673112,64 32,64 Z",
  id: "path-1"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "icons/status-ok-fill-green",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons/status-ok"
}, /*#__PURE__*/React.createElement("g", {
  id: "alert-2",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#000000",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "colours/green",
  mask: "url(#mask-2)",
  fill: "#427945",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-4.000000, -4.000000)",
  id: "Rectangle"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 68,
  height: 68
})))), /*#__PURE__*/React.createElement("path", {
  d: "M25.2951803,42.285711 L25.2951803,44 C24.4545349,44 23.6446704,43.6628108 23.0451097,43.0482094 L16.9117,36.7609353 C15.6961852,35.5159909 15.6961852,33.5134273 16.9111891,32.2690064 C18.1491865,30.9999523 20.1733329,30.9999523 21.4112743,32.2689489 L25.3714296,36.3280692 L41.5242603,20.8733432 C42.8052857,19.6490259 44.828385,19.7213067 46.0218706,21.0313468 C47.192594,22.3174636 47.1248946,24.3172914 45.8683594,25.5202577 L27.4680901,43.1248937 C26.8757066,43.692146 26.0982268,44 25.2951803,44 L25.2951803,42.285711 Z",
  id: "Fill-1",
  fill: "#FFFFFF",
  fillRule: "nonzero"
})));

var SvgStatusOkFillGreen = function SvgStatusOkFillGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStatusOkFillGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/status-ok-fill-green.300d3407.svg";
export { ForwardRef as ReactComponent };